import React, { createContext, useContext, useState, useEffect } from "react";
import {fetchWithAuth} from "../utils/fetchWithAuth";

// Create the GameDetailConfig context
const GameDetailConfigContext = createContext();

// Provider component for detailed game configuration
export const GameDetailConfigProvider = ({ gameId, children }) => {
    const [gameDetailConfig, setGameDetailConfig] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Function to fetch detailed game configuration
    useEffect(() => {
        const fetchGameDetailConfig = async () => {
            try {
                setLoading(true);
                setError(null);

                const wsUrl = process.env.REACT_APP_GAMES_CLOUD_URL; // Fetch API path, e.g., "/room1/api/config"

                if (!wsUrl) {
                    console.error("REACT_APP_GAMES_CLOUD_URL is not defined. - set to default");
                }

                const updatedUrl = wsUrl.replace(/^ws/, "http").replace(/ws$/, `game/${gameId}/config`);
                const response = await fetchWithAuth(updatedUrl, {
                    method: "GET",
                });
                if (!response.ok) {
                    throw new Error(`Error fetching config for gameId ${gameId}: ${response.statusText}`);
                }

                const data = await response.json();
                setGameDetailConfig(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        if (gameId) {
            fetchGameDetailConfig();
        }
    }, [gameId]);

    return (
        <GameDetailConfigContext.Provider value={{ gameDetailConfig, loading, error }}>
            {children}
        </GameDetailConfigContext.Provider>
    );
};

// Custom hook to use the GameDetailConfig context
export const useGameDetailConfig = () => {
    const context = useContext(GameDetailConfigContext);
    if (!context) {
        throw new Error("useGameDetailConfig must be used within a GameDetailConfigProvider");
    }
    return context;
};